import { useState, useEffect } from "react";

export default function ProfileModal({ user, onClose }) {
  const [isEditing, setIsEditing] = useState(false);
  const [imageError, setImageError] = useState(false);
    const [formData, setFormData] = useState({
    name: user?.name || "",
    username: user?.username || "",
    email: user?.email || "",
    phoneNumber: user?.phoneNumber || "",
    gender: user?.gender || "",
    zoneinfo: user?.zoneinfo || "",
    picture: user?.picture || "",
    facilityId: user?.facilityId || "",
    facilityName: user?.facilityName || "",
    address1: user?.address1 || "",
    address2: user?.address2 || "",
    city: user?.city || "",
    state: user?.state || "",
    country: user?.country || "",
  });

  // Update formData when user prop changes
  useEffect(() => {
    if (user) {
      console.log("\n=== ProfileModal - User Data ===");
      console.log("Full user object:", user);
      console.log("Picture attribute:", user.picture);
      console.log("Picture type:", typeof user.picture);
      console.log("Picture is empty?", !user.picture);
      console.log("Picture is undefined?", user.picture === undefined);
      console.log("Picture is null?", user.picture === null);
      console.log("Picture length:", user.picture?.length);
      console.log("================================\n");
      
      setFormData({
        name: user.name || "",
        username: user.username || "",
        email: user.email || "",
        phoneNumber: user.phoneNumber || "",
        gender: user.gender || "",
        zoneinfo: user.zoneinfo || "",
        picture: user.picture || "",
        facilityId: user.facilityId || "",
        facilityName: user.facilityName || "",
        address1: user.address1 || "",
        address2: user.address2 || "",
        city: user.city || "",
        state: user.state || "",
        country: user.country || "",
      });
      setImageError(false); // Reset image error when user changes
    }
  }, [user]);

  // Close modal on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

    // Convert S3 URI to HTTPS URL or return presigned URL as-is
  const getImageUrl = (s3Uri) => {
    console.log('\n=== ProfileModal - getImageUrl Called ===');
    console.log('Input s3Uri:', s3Uri);
    console.log('Input type:', typeof s3Uri);
    
    if (!s3Uri) {
      console.log('Result: NULL (no URI provided)');
      console.log('========================================\n');
      return null;
    }
    
    // Trim whitespace from the URI
    s3Uri = s3Uri.trim();
    console.log('Trimmed s3Uri:', s3Uri);
    
    // If it's already a presigned URL (has AWS signature), return it as-is
    if (s3Uri.includes('X-Amz-Algorithm') || s3Uri.includes('X-Amz-Credential')) {
      console.log('Result: Presigned URL detected, using as-is');
      console.log('========================================\n');
      return s3Uri;
    }
    
    // If it's already an HTTPS URL, return it
    if (s3Uri.startsWith('http://') || s3Uri.startsWith('https://')) {
      console.log('Result: Already HTTPS URL');
      console.log('Final URL:', s3Uri);
      console.log('========================================\n');
      return s3Uri;
    }
    
    // Convert s3:// URI to HTTPS URL (legacy support)
    // Format: s3://bucket-name/key -> https://bucket-name.s3.amazonaws.com/key (path-style)
    // or https://s3.amazonaws.com/bucket-name/key (alternative path-style)
    if (s3Uri.startsWith('s3://')) {
      const pathParts = s3Uri.replace('s3://', '').split('/');
      const bucket = pathParts[0];
      const key = pathParts.slice(1).join('/');
      
      // Try multiple URL formats
      // Format 1: Virtual-hosted style with region
      const url1 = `https://${bucket}.s3.us-east-1.amazonaws.com/${key}`;
      // Format 2: Virtual-hosted style without region (works for us-east-1)
      const url2 = `https://${bucket}.s3.amazonaws.com/${key}`;
      // Format 3: Path-style (legacy but more reliable for public buckets)
      const url3 = `https://s3.amazonaws.com/${bucket}/${key}`;
      
      console.log('Result: Converted from s3:// URI');
      console.log('Bucket:', bucket);
      console.log('Key:', key);
      console.log('URL Format 1 (with region):', url1);
      console.log('URL Format 2 (no region):', url2);
      console.log('URL Format 3 (path-style):', url3);
      console.log('Using Format 2 (most compatible)');
      console.log('========================================\n');
      
      // Return the most compatible format
      return url2;
    }
    
    console.log('Result: Invalid S3 URI format (not http/https/s3)');
    console.log('========================================\n');
    return null;
  };

  // Get user initials for avatar
  const getInitials = (name) => {
    if (!name) return "U";
    const parts = name.trim().split(" ");
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const handleSave = () => {
    // TODO: Implement save functionality with backend
    console.log("Saving profile:", formData);
    setIsEditing(false);
    // You would call an API here to update the user profile
  };

  const handleCancel = () => {
    setFormData({
      name: user?.name || "",
      username: user?.username || "",
      email: user?.email || "",
      phoneNumber: user?.phoneNumber || "",
      gender: user?.gender || "",
      zoneinfo: user?.zoneinfo || "",
      picture: user?.picture || "",
      facilityId: user?.facilityId || "",
      facilityName: user?.facilityName || "",
      address1: user?.address1 || "",
      address2: user?.address2 || "",
      city: user?.city || "",
      state: user?.state || "",
      country: user?.country || "",
    });
    setIsEditing(false);
  };

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0, 0, 0, 0.6)",
          backdropFilter: "blur(4px)",
          zIndex: 9998,
          animation: "fadeIn 0.2s ease-out",
        }}
      />

      {/* Modal */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 500,
          maxHeight: "85vh",
          background: "linear-gradient(180deg, #0e2240 0%, #0a1a30 100%)",
          border: "2px solid rgba(255,255,255,0.25)",
          borderRadius: 16,
          boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
          zIndex: 9999,
          animation: "slideUp 0.3s ease-out",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "24px 24px 20px",
            borderBottom: "1px solid rgba(255,255,255,0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: 20,
              fontWeight: 700,
              color: "#ffffff",
            }}
          >
            My Profile
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: 4,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 6,
              transition: "background 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.1)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffffff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: "24px", overflowY: "auto", flex: 1 }}>
          {/* Avatar Section */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: 32,
            }}
          >
            <div
              style={{
                width: 100,
                height: 100,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #0a1a30 0%, #1a2d4a 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 36,
                fontWeight: 700,
                color: "#ffffff",
                border: "3px solid rgba(255,255,255,0.3)",
                marginBottom: 16,
                overflow: "hidden",
                position: "relative",
              }}
            >
              {(() => {
                const imageUrl = getImageUrl(user?.picture);
                console.log('\n=== ProfileModal - Rendering Avatar ===');
                console.log('Image URL:', imageUrl);
                console.log('Image Error State:', imageError);
                console.log('Will show image?', imageUrl && !imageError);
                console.log('Will show initials?', !imageUrl || imageError);
                console.log('=====================================\n');
                
                                if (imageUrl && !imageError) {
                  return (
                    <img 
                      src={imageUrl} 
                      alt="Profile" 
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        userSelect: "none",
                        pointerEvents: "none",
                        WebkitUserSelect: "none",
                        MozUserSelect: "none",
                        msUserSelect: "none",
                      }}
                      onLoad={() => {
                        console.log('✓ ProfileModal - Image loaded successfully:', imageUrl);
                      }}
                      onError={(e) => {
                        console.error('\n=== ProfileModal - Image Load Error ===');
                        console.error('Failed URL:', imageUrl);
                        console.error('Error event:', e);
                        console.error('Error type:', e.type);
                        console.error('Target:', e.target);
                        console.error('=====================================\n');
                        setImageError(true);
                      }}
                      onContextMenu={(e) => e.preventDefault()}
                      onDragStart={(e) => e.preventDefault()}
                      draggable={false}
                    />
                  );
                } else {
                  const initials = getInitials(formData.name || user?.name);
                  console.log('Showing initials:', initials);
                  return initials;
                }
              })()}
            </div>
            <div
              style={{
                fontSize: 18,
                fontWeight: 700,
                color: "#ffffff",
                marginBottom: 4,
              }}
            >
              {formData.name || user?.name || "User"}
            </div>
            <div
              style={{
                fontSize: 13,
                color: "rgba(255,255,255,0.6)",
              }}
            >
              {formData.email || user?.email || "No email"}
            </div>
          </div>

          {/* Profile Information */}
          <div style={{ marginBottom: 24 }}>
            <h3
              style={{
                margin: "0 0 16px 0",
                fontSize: 14,
                fontWeight: 600,
                color: "rgba(255,255,255,0.7)",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Profile Information
            </h3>

            {/* Full Name Field */}
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#ffffff",
                  marginBottom: 8,
                }}
              >
                Full Name
              </label>
              {isEditing ? (
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    borderRadius: 8,
                    fontSize: 14,
                    color: "#ffffff",
                    outline: "none",
                    transition: "border-color 0.2s",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "rgba(74,144,226,0.5)")}
                  onBlur={(e) => (e.target.style.borderColor = "rgba(255,255,255,0.2)")}
                />
              ) : (
                <div
                  style={{
                    padding: "10px 14px",
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    borderRadius: 8,
                    fontSize: 14,
                    color: "#ffffff",
                  }}
                >
                  {formData.name || "Not set"}
                </div>
              )}
            </div>

            {/* Username Field */}
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#ffffff",
                  marginBottom: 8,
                }}
              >
                Username
              </label>
              <div
                style={{
                  padding: "10px 14px",
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: 8,
                  fontSize: 14,
                  color: "rgba(255,255,255,0.6)",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <span>{formData.username || "Not set"}</span>
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: "rgba(255,255,255,0.5)",
                  marginTop: 6,
                }}
              >
                Username cannot be changed
              </div>
            </div>

            {/* Email Field */}
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#ffffff",
                  marginBottom: 8,
                }}
              >
                Email Address
              </label>
              <div
                style={{
                  padding: "10px 14px",
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: 8,
                  fontSize: 14,
                  color: "rgba(255,255,255,0.6)",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                <span>{formData.email || "Not set"}</span>
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: "rgba(255,255,255,0.5)",
                  marginTop: 6,
                }}
              >
                Email cannot be changed for security reasons
              </div>
            </div>

                        {/* Phone Number Field */}
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#ffffff",
                  marginBottom: 8,
                }}
              >
                Phone Number
              </label>
              {isEditing ? (
                <input
                  type="tel"
                  value={formData.phoneNumber}
                  onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                  placeholder="+1 (555) 123-4567"
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    borderRadius: 8,
                    fontSize: 14,
                    color: "#ffffff",
                    outline: "none",
                    transition: "border-color 0.2s",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "rgba(74,144,226,0.5)")}
                  onBlur={(e) => (e.target.style.borderColor = "rgba(255,255,255,0.2)")}
                />
              ) : (
                <div
                  style={{
                    padding: "10px 14px",
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    borderRadius: 8,
                    fontSize: 14,
                    color: "#ffffff",
                  }}
                >
                  {formData.phoneNumber || "Not set"}
                </div>
              )}
            </div>

                        {/* Gender Field */}
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#ffffff",
                  marginBottom: 8,
                }}
              >
                Gender
              </label>
              {isEditing ? (
                <select
                  value={formData.gender}
                  onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    borderRadius: 8,
                    fontSize: 14,
                    color: "#ffffff",
                    outline: "none",
                    transition: "border-color 0.2s",
                    cursor: "pointer",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "rgba(74,144,226,0.5)")}
                  onBlur={(e) => (e.target.style.borderColor = "rgba(255,255,255,0.2)")}
                >
                  <option value="" style={{ background: "#0a1a30" }}>Select gender</option>
                  <option value="Male" style={{ background: "#0a1a30" }}>Male</option>
                  <option value="Female" style={{ background: "#0a1a30" }}>Female</option>
                  <option value="Other" style={{ background: "#0a1a30" }}>Other</option>
                  <option value="Prefer not to say" style={{ background: "#0a1a30" }}>Prefer not to say</option>
                </select>
              ) : (
                <div
                  style={{
                    padding: "10px 14px",
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    borderRadius: 8,
                    fontSize: 14,
                    color: "#ffffff",
                  }}
                >
                  {formData.gender || "Not set"}
                </div>
              )}
            </div>

            {/* Facility Information Section */}
            <h3
              style={{
                margin: "24px 0 16px 0",
                fontSize: 14,
                fontWeight: 600,
                color: "rgba(255,255,255,0.7)",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Facility Information
            </h3>

            {/* Facility Name Field */}
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#ffffff",
                  marginBottom: 8,
                }}
              >
                Facility Name
              </label>
              <div
                style={{
                  padding: "10px 14px",
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: 8,
                  fontSize: 14,
                  color: "rgba(255,255,255,0.6)",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                  <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
                <span>{formData.facilityName || "Not set"}</span>
              </div>
            </div>

            {/* Facility ID Field */}
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#ffffff",
                  marginBottom: 8,
                }}
              >
                Facility ID
              </label>
              <div
                style={{
                  padding: "10px 14px",
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: 8,
                  fontSize: 12,
                  color: "rgba(255,255,255,0.6)",
                  fontFamily: "monospace",
                }}
              >
                {formData.facilityId || "Not set"}
              </div>
            </div>

            {/* Location Section */}
            <h3
              style={{
                margin: "24px 0 16px 0",
                fontSize: 14,
                fontWeight: 600,
                color: "rgba(255,255,255,0.7)",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Location
            </h3>

            {/* Address 1 Field */}
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#ffffff",
                  marginBottom: 8,
                }}
              >
                Address Line 1
              </label>
              <div
                style={{
                  padding: "10px 14px",
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: 8,
                  fontSize: 14,
                  color: "#ffffff",
                }}
              >
                {formData.address1 || "Not set"}
              </div>
            </div>

            {/* Address 2 Field */}
            {formData.address2 && (
              <div style={{ marginBottom: 16 }}>
                <label
                  style={{
                    display: "block",
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#ffffff",
                    marginBottom: 8,
                  }}
                >
                  Address Line 2
                </label>
                <div
                  style={{
                    padding: "10px 14px",
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    borderRadius: 8,
                    fontSize: 14,
                    color: "#ffffff",
                  }}
                >
                  {formData.address2}
                </div>
              </div>
            )}

            {/* City, State, Country in a grid */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
              {/* City */}
              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#ffffff",
                    marginBottom: 8,
                  }}
                >
                  City
                </label>
                <div
                  style={{
                    padding: "10px 14px",
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    borderRadius: 8,
                    fontSize: 14,
                    color: "#ffffff",
                  }}
                >
                  {formData.city || "Not set"}
                </div>
              </div>

              {/* State */}
              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#ffffff",
                    marginBottom: 8,
                  }}
                >
                  State
                </label>
                <div
                  style={{
                    padding: "10px 14px",
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    borderRadius: 8,
                    fontSize: 14,
                    color: "#ffffff",
                  }}
                >
                  {formData.state || "Not set"}
                </div>
              </div>
            </div>

                        {/* Country */}
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#ffffff",
                  marginBottom: 8,
                }}
              >
                Country
              </label>
              <div
                style={{
                  padding: "10px 14px",
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: 8,
                  fontSize: 14,
                  color: "#ffffff",
                }}
              >
                {formData.country || "Not set"}
              </div>
            </div>

            {/* User ID (Read-only) - At the end */}
            <h3
              style={{
                margin: "24px 0 16px 0",
                fontSize: 14,
                fontWeight: 600,
                color: "rgba(255,255,255,0.7)",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              System Information
            </h3>

            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#ffffff",
                  marginBottom: 8,
                }}
              >
                User ID
              </label>
              <div
                style={{
                  padding: "10px 14px",
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: 8,
                  fontSize: 12,
                  color: "rgba(255,255,255,0.6)",
                  fontFamily: "monospace",
                  wordBreak: "break-all",
                }}
              >
                {user?.userId || "N/A"}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div
            style={{
              display: "flex",
              gap: 12,
              justifyContent: "flex-end",
            }}
          >
            {isEditing ? (
              <>
                <button
                  onClick={handleCancel}
                  style={{
                    padding: "10px 20px",
                    background: "transparent",
                    border: "1px solid rgba(255,255,255,0.3)",
                    borderRadius: 8,
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#ffffff",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.05)";
                    e.currentTarget.style.borderColor = "rgba(255,255,255,0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.borderColor = "rgba(255,255,255,0.3)";
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSave}
                  style={{
                    padding: "10px 20px",
                    background: "linear-gradient(135deg, #4a90e2 0%, #357abd 100%)",
                    border: "none",
                    borderRadius: 8,
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#ffffff",
                    cursor: "pointer",
                    transition: "transform 0.2s, box-shadow 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(74,144,226,0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  Save Changes
                </button>
              </>
            ) : (
              <button
                onClick={() => setIsEditing(true)}
                style={{
                  padding: "10px 20px",
                  background: "linear-gradient(135deg, #4a90e2 0%, #357abd 100%)",
                  border: "none",
                  borderRadius: 8,
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#ffffff",
                  cursor: "pointer",
                  transition: "transform 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(74,144,226,0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                Edit Profile
              </button>
            )}
          </div>
        </div>
      </div>


    </>
  );
}
